/**
 * Created by alex.y on 10/24/2017.
 */
export class AgentColorLink {
    public Email: string;
    public color: string;

    constructor(obj : Partial<AgentColorLink>){
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/report/agentColorLink.ts